<template>
  <search-template :search-config="searchConfig" :vertical="Vertical.Fish">
    <template #emptyStateBottom>
      <div class="discover-cta-wrapper" data-test="search-discover-cta">
        <search-discover-cta />
      </div>
    </template>
    <template #noResults>
      <div
        class="discover-cta-wrapper no-results-cta"
        data-test="no-results-cta"
      >
        <search-discover-cta show-description />
      </div>
    </template>
  </search-template>
</template>

<script setup lang="ts">
import searchTemplate from '@/components/search/search-template.vue'
import searchDiscoverCta from '@/components/search/search-discover-cta.vue'
import type { UseSearchConfig } from '@onxmaps/search-web-vue'
import { Vertical } from '@/types/verticals'
import { createSearchQuery } from '@onxmaps/search-web'

const fishSearchQuery = createSearchQuery(`
    about {
      ... on Lake {
        id
      }
      ... on FishingRegion {
        id
        area
        waterbodies {
          name
          id
          area
        } 
      }
      ... on WaterAccessSite {
        id
        primaryAmenity {
          id
          slug
        }
        parentWaterbody: waterbody {
          id
          name
        }
      }
      ... on FishingArea {
        id
        label
        coverPhoto {
          contentUrl
        }
        waterbody {
          name
        }
      }
    }
  `)

const searchConfig: UseSearchConfig = {
  customQuery: fishSearchQuery,
  useAutocomplete: true,
}
</script>

<style scoped>
.discover-cta-wrapper {
  border-top: 1px solid var(--ys-color-divider-base);
  padding: var(--ys-spacing-250) var(--ys-spacing-250) 0 var(--ys-spacing-250);
}

.no-results-cta {
  margin-top: var(--ys-spacing-100);
}
</style>
